if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        this.includeParent = this.dataset.includeParent;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Check addon state on initialization
        this.updateSubmitButtonState();
      }

      async performRegularAddToCart() {
        const items = this.getItems();
        console.log('Items to add:', items);

        const cartModal = document.querySelector('cart-modal');
        const isInsideModal = !!this.closest('cart-modal');
        const sectionsToFetch = cartModal ? ['cart-modal', 'cart-icon-bubble'] : [];

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const sectionsUrl = new URL(window.location.href);
        const mainVariantId = items.items?.[0]?.id;
        if (mainVariantId) sectionsUrl.searchParams.set('added_main_variant', mainVariantId);

        const body = {
          ...items,
          sections_url: `${sectionsUrl.pathname}${sectionsUrl.search}`,
        };
        if (sectionsToFetch.length) body.sections = sectionsToFetch;
        config.body = JSON.stringify(body);

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const responseData = await response.json();

          if (responseData.status) {
            this.handleErrorMessage(responseData.description);
            throw new Error(responseData.description || 'Error adding items to cart.');
          }

          if (cartModal && typeof cartModal.renderContents === 'function') {
            let addedProductIds = [];
            if (isInsideModal) {
              const addedItems = Array.isArray(responseData.items)
                ? responseData.items
                : (responseData.id ? [responseData] : []);
              addedProductIds = addedItems
                .map((entry) => entry && entry.product_id)
                .filter((id) => id != null);
            }
            const addedVariantId = items.items && items.items[0] && items.items[0].id;
            cartModal.renderContents(responseData, {
              skipAddedItem: isInsideModal,
              addedProductIds,
              addedVariantId,
            });
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (e) {
          console.error('Error in performRegularAddToCart:', e);
          this.handleErrorMessage(e.message || 'Could not add items to cart.');
          throw e; // Re-throw to be caught by onSubmitHandler's catch
        }
      }

      async handleExistingCartThenAdd(cartId) {
        console.log('Handling existing cart then adding new items for ID:', cartId);
        // Note: Button loading state is managed by onSubmitHandler

        try {
          const cartGetResponse = await fetch('/cart.js');
          if (!cartGetResponse.ok) {
            const errorMsg = `Failed to fetch cart: ${cartGetResponse.status}`;
            this.handleErrorMessage(errorMsg);
            throw new Error(errorMsg);
          }
          const cartData = await cartGetResponse.json();
          console.log('Current Cart Data (before removal):', cartData);

          const itemsToRemove = cartData.items.filter(
            (item) => item.properties && item.properties._ID === cartId
          );

          if (itemsToRemove.length > 0) {
            console.log(`Found ${itemsToRemove.length} item(s) to remove with _ID: ${cartId}`);
            const updates = {};
            itemsToRemove.forEach(item => {
              updates[item.key] = 0;
            });

            const updateConfig = fetchConfig('javascript');
            updateConfig.headers['Content-Type'] = 'application/json';
            updateConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            updateConfig.body = JSON.stringify({ updates });

            const updateResponse = await fetch(`${routes.cart_update_url}`, updateConfig);
            const updateResponseData = await updateResponse.json();
            console.log('Response from cart/update.js (removal):', updateResponseData);

            if (!updateResponse.ok || updateResponseData.status) {
              const errorMessage = updateResponseData.description || updateResponseData.message || 'Error updating cart (removing items).';
              console.error('Error updating cart (removing items):', errorMessage, updateResponseData);
              this.handleErrorMessage(errorMessage);
              throw new Error(errorMessage);
            }
            console.log('Items successfully removed.');
          } else {
            console.log(`No items found in cart with _ID: ${cartId} to remove.`);
          }

          // If removal was successful (or not needed), proceed to add new items
          console.log('Proceeding to add new items to cart.');
          await this.performRegularAddToCart();

        } catch (e) {
          console.error('Error in handleExistingCartThenAdd:', e);
          // Error message should have been handled by the part that failed (fetch cart, update cart, or add cart)
          // Re-throw to ensure onSubmitHandler's finally runs and button is reset.
          throw e;
        }
        // No 'finally' block here for button state; onSubmitHandler manages it.
      }

      getItems() {
        const formData = JSON.parse(serializeForm(this.form));
        const sharedId = Date.now().toString();


        // 1. Determine initial properties for the main item (from form fields like properties[Note])
        let initialMainItemProperties = this.getSelectedProperties(formData);

        // 2. Create the main item (will be items[0])
        let items;
        if (initialMainItemProperties && Object.keys(initialMainItemProperties).length > 0) {
          items = [this.createItemWithProperties(formData, initialMainItemProperties)];
        } else {
          items = [this.createItemFromForm(formData)];
        }

        // 3. Prepare the properties object for the main item.
        let mainProductFinalProperties = items[0].properties ? { ...items[0].properties } : {};
        mainProductFinalProperties['_ID'] = sharedId; // Add _ID

        // Add "Auto" property from enhanced-car-picker
        const carPickerElement = document.querySelector('car-picker-button');
        if (carPickerElement && carPickerElement.dataset.car) {
          mainProductFinalProperties['Auto'] = carPickerElement.dataset.brand + ' ' + carPickerElement.dataset.car;
        }

        // 4. Handle addon items and their properties for the main item
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        let addonItemsToSubmit = [];
        let addonSkus = [];
        if (this.hasAddons && this.includeParent === 'true') {
          const addonCheckboxes = this.addOnform.querySelectorAll('input[type="radio"]:checked');

          addonCheckboxes.forEach(checkbox => {
            const addonSku = checkbox.dataset.addonSku;
            if (addonSku) {
              addonSkus.push(addonSku);
            }

            // New way: use data-attributes for key and value
            const addonType = checkbox.dataset.addonType;
            const addonTitle = checkbox.dataset.addonTitle;

            if (addonType && addonTitle !== undefined) { // addonTitle can be an empty string
              mainProductFinalProperties[`_${addonType}`] = addonTitle;
            } else {
              console.warn(`Addon input ${checkbox.id} is missing data-addon-type or data-addon-title.`);
            }
          });

          addonItemsToSubmit = this.createAddonItems(formData, sharedId);
          items = items.concat(addonItemsToSubmit);

          // 5. Combine SKUs and add to properties
          const mainSkuInput = this.form.querySelector('input[name="sku"]');
          if (mainSkuInput && mainSkuInput.value) {
            const mainSku = mainSkuInput.value;
            if (addonSkus.length > 0) {
              const allSkus = [mainSku + addonSkus[0], ...addonSkus.slice(1)].join('-');
              mainProductFinalProperties['Productcode'] = allSkus;
            } else {
              mainProductFinalProperties['Productcode'] = mainSku;
            }
          }

          // 6. Ensure the main item (items[0]) has the final set of properties.
          if (Object.keys(mainProductFinalProperties).length > 0) {
            items[0].properties = mainProductFinalProperties;
          } else if (items[0].hasOwnProperty('properties')) {
            // If final properties are empty, remove the key if it exists (e.g. was an empty object)
            delete items[0].properties;
          }
        }

        return { items };
      }

      getSelectedProperties(formData) {
        // Extract properties from formData that have a 'properties' key
        if (formData.properties) {
          return Object.entries(formData.properties)
            .filter(([key, value]) => value) // Include only non-empty values
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
        }
        return {};
      }

      createItemWithProperties(formData, properties) {
        let item = {
          quantity: formData.quantity || 1,
          id: formData.id,
          properties: this.getSelectedProperties({ properties }) // Use the updated function
        };
      
        return item;
      }


      createItemFromForm(formData) {
        let item = {
          quantity: formData.quantity || 1,
          id: formData.id
        };
    
      
        return item;
      }

      createAddonItems(formData, sharedId) { 
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        console.log('addonitems');
        let addonItems = [];
        const checkboxes = this.addOnform.querySelectorAll('input[type="radio"]:checked');
        // Preserving this log, ensuring it uses this.addOnform for consistency with querySelector
        console.log(this.addOnform); 
        checkboxes.forEach(checkbox => {
          addonItems.push({
            quantity: formData.quantity || 1, 
            id: checkbox.value,
            parent_id: formData.id,
            properties: { '_ID': sharedId } // Add sharedId to each addon item's properties
          });
        });
    
        return addonItems;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
          if (this.addOnform) {
            const allAddonDetails = Array.from(this.addOnform.querySelectorAll('details.product-variant-picker__option'));
            const allAddonsSelected = allAddonDetails.every(detail => detail.querySelector('input[type="radio"]:checked'));
            if (!allAddonsSelected) {
              const firstIncomplete = allAddonDetails.find(d => !d.querySelector('input[type="radio"]:checked'));
              if (firstIncomplete) {
                firstIncomplete.setAttribute('open', '');
                firstIncomplete.classList.add('product-variant-picker__option--required');
                const warning = firstIncomplete.querySelector('[data-addon-warning]');
                if (warning) warning.hidden = false;
                requestAnimationFrame(() => {
                  const headerBottom = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position').trim();
                  const offsetPx = headerBottom ? parseInt(headerBottom, 10) : 0;
                  const rect = firstIncomplete.getBoundingClientRect();
                  const targetScrollY = window.scrollY + rect.top - offsetPx;
                  window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
                });
              }
            }
          }
          return;
        }

        this.handleErrorMessage(); // Clear previous errors

        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        if (this.addOnform) {
            const variantSelects = this.closest('.shopify-section').querySelector('variant-selects');
            if (variantSelects) {
                const allVariantDetails = Array.from(variantSelects.querySelectorAll('details'));
                const allVariantsSelected = allVariantDetails.every(detail => {
                    const selectedValueSpan = detail.querySelector('[data-selected-value]');
                    return selectedValueSpan && selectedValueSpan.textContent.trim() !== '';
                });

                if (!allVariantsSelected) {
                    this.handleErrorMessage(window.variantStrings.select_all_options);
                    return;
                }
            }

            const allAddonDetails = Array.from(this.addOnform.querySelectorAll('details'));
            const allAddonsSelected = allAddonDetails.every(detail => detail.querySelector('input[type="radio"]:checked'));

            if (!allAddonsSelected) {
                const firstIncomplete = allAddonDetails.find(d => !d.querySelector('input[type="radio"]:checked'));
                if (firstIncomplete) {
                  firstIncomplete.setAttribute('open', '');
                  firstIncomplete.classList.add('product-variant-picker__option--required');
                  const warning = firstIncomplete.querySelector('[data-addon-warning]');
                  if (warning) warning.hidden = false;
                  requestAnimationFrame(() => {
                    const headerBottom = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position').trim();
                    const offsetPx = headerBottom ? parseInt(headerBottom, 10) : 0;
                    const rect = firstIncomplete.getBoundingClientRect();
                    const targetScrollY = window.scrollY + rect.top - offsetPx;
                    window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
                  });
                }
                return;
            }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        try {
          const urlParams = new URLSearchParams(window.location.search);
          const underscoreId = urlParams.get('_id');

          if (underscoreId) {
            console.log('URL Parameter _id found:', underscoreId);
            await this.handleExistingCartThenAdd(underscoreId);
          } else {
            await this.performRegularAddToCart();
          }
        } catch (e) {
          console.error('Error during submission process:', e);
          // Error messages should be handled by the specific functions (performRegularAddToCart or handleExistingCartThenAdd)
          // This catch is mainly to ensure the finally block runs.
        } finally {
          this.submitButton.classList.remove('loading');
          // Only re-enable if no critical error stopped the process before a redirect or if an error message is shown.
          // If a redirect happens, the button state on the new page is what matters.
          // If an error message is shown, the user might want to try again.
          if (!window.location.href.includes(window.routes.cart_url)) { // Avoid re-enabling if redirecting
             if (this.errorMessageWrapper && !this.errorMessageWrapper.hasAttribute('hidden')) {
                this.submitButton.removeAttribute('aria-disabled');
             } else if (!this.error) { // If no error was explicitly set by handleErrorMessage
                const anErrorOccurred = this.errorMessageWrapper && !this.errorMessageWrapper.hasAttribute('hidden');
                if (!anErrorOccurred) { // If truly no error message shown
                    this.submitButton.removeAttribute('aria-disabled');
                } else {
                  // If an error message is shown, keep it disabled until user interaction or new attempt
                }
             }
          }
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateSubmitButtonState() {
        this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
        
        if (!this.addOnform) {
          // No addons, enable button
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('disabled');
          return;
        }

        const allAddonDetails = Array.from(this.addOnform.querySelectorAll('details'));
        const allAddonsSelected = allAddonDetails.every(detail => detail.querySelector('input[type="radio"]:checked'));

        if (allAddonsSelected) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.setAttribute('aria-disabled', 'true');
          // Only aria-disabled when addons incomplete so click still fires and we can show feedback
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
if (!customElements.get('addon-product')) {

class AddonProduct  extends HTMLElement {
  constructor() {
    super();
    this.inputList = this.querySelectorAll('input[type="radio"]'); // Support for multiple checkboxes
    this.form = this.closest('.shopify-section').querySelector('product-form');
    this.includeParent = this.dataset.includeParent;

    this.selectAddonsFromUrlParams(); // Call the new method here
    this.selectQuantityFromUrlParams(); // Call method to select quantity

    this.init();
    this.checkInitialAddonState(); // New method call to check the initial state
    this.conditionallyOpenFirstAddon();
  }

  selectAddonsFromUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsToSelect = new Map();

    // Create a map of relevant URL parameters
    urlParams.forEach((value, key) => {
      const normalizedKey = key.startsWith('_') ? key.substring(1) : key;
      paramsToSelect.set(normalizedKey, value);
    });

    if (paramsToSelect.size === 0) {
      return; // No URL parameters to process
    }
    console.log(paramsToSelect);

    this.inputList.forEach(input => {
      const addonType = input.dataset.addonTypeHandle || input.dataset.addonType;
      const addonTitle = input.dataset.addonTitleHandle;

      // Check if this input corresponds to a URL parameter
      if (addonType && addonTitle !== undefined && paramsToSelect.has(addonType)) {
        if (paramsToSelect.get(addonType) === addonTitle) {
          input.checked = true;
          console.log(input);
          // No need to call updateSelectedValue here;
          // checkInitialAddonState will handle updating the UI for all checked inputs.
        }
      }
    });
  }

  selectQuantityFromUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const quantity = urlParams.get('quantity');

    if (quantity) {
      const quantityInput = this.closest('.shopify-section').querySelector('quantity-input');
      if (quantityInput) {
        const inputElement = quantityInput.querySelector('input[type="number"].quantity__input');
        const selectElement = quantityInput.querySelector('select.quantity__input');
        if (inputElement) {
          inputElement.value = quantity;
          // Dispatch an event to ensure any listeners on the input are triggered
          inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (selectElement) {
          selectElement.value = quantity;
           // Dispatch an event to ensure any listeners on the select are triggered
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  init() {
    this.inputList.forEach(input => {
      input.addEventListener('change', this.onInputChange.bind(this));
    });
    this.querySelectorAll('details.product-variant-picker__option').forEach((detailsEl) => {
      detailsEl.addEventListener('toggle', () => {
        if (!detailsEl.open) return;
        const radios = detailsEl.querySelectorAll('input[type="radio"]');
        if (radios.length !== 1) return;
        if (detailsEl.querySelector('input[type="radio"]:checked')) return;
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  onInputChange(event) {
    const selectedInput = event.target;
    if (selectedInput.checked) {
        this.updateSelectedValue(selectedInput);
    }
    // Update overall addon status for the main form
    this.form.hasAddons = this.querySelectorAll('input[type="radio"]:checked').length > 0;
    this.updatePrice();
    // Update submit button state when addons change
    if (this.form && typeof this.form.updateSubmitButtonState === 'function') {
      this.form.updateSubmitButtonState();
    }
  }

  updatePrice() {
    const currentVariant = this.getCurrentVariant();
    if (!currentVariant) return;

    const basePrice = currentVariant.price;

    let totalAddonPrice = 0;
    let totalAddonGross = 0;
    let totalAddonBruto = 0;
    const checkedAddons = this.querySelectorAll('input[type="radio"]:checked');
    checkedAddons.forEach(input => {
        const price = parseInt(input.dataset.addonPrice, 10);
        if (!isNaN(price)) {
            totalAddonPrice += price;
        }
        const priceGross = parseInt(input.dataset.addonPriceGross, 10);
        if (!isNaN(priceGross)) {
            totalAddonGross += priceGross;
        }
        const priceBruto = parseInt(input.dataset.addonPriceBruto, 10);
        if (!isNaN(priceBruto)) {
            totalAddonBruto += priceBruto;
        }
    });

    const priceElementContainer = this.closest('product-info')?.querySelector('.price');
    if (!priceElementContainer) return;

    const showExclVat = priceElementContainer.dataset.b2b === 'true';
    const vatPercentage = parseInt(priceElementContainer.dataset.vatPercentage, 10) || 0;
    const vatDivisor = vatPercentage + 100;

    const totalAddonForCalc = totalAddonGross > 0 ? totalAddonGross : totalAddonPrice;
    const displayNetTotal = showExclVat && vatPercentage > 0
      ? Math.round(((basePrice + totalAddonForCalc) * 100) / vatDivisor)
      : basePrice + totalAddonPrice;
    const newFormattedPrice = window.Currency.formatMoney(displayNetTotal, window.currency.moneyFormat);

    const salePriceElement = priceElementContainer.querySelector('.price-item--sale');
    if (salePriceElement) {
      salePriceElement.innerHTML = newFormattedPrice;
    }

    const netPriceElement = priceElementContainer.querySelector('.price__regular .price__net-price');
    if (netPriceElement) {
      netPriceElement.textContent = newFormattedPrice;
    } else {
      const regularPriceElement = priceElementContainer.querySelector('.price__regular .price-item--regular');
      if (regularPriceElement) {
        regularPriceElement.innerHTML = newFormattedPrice;
      }
    }

    const grossPriceElement = priceElementContainer.querySelector('.price__gross-price');
    const variantRetailPricesJson = priceElementContainer.dataset.variantRetailPrices;
    if (grossPriceElement && variantRetailPricesJson) {
      let retailMap;
      try {
        retailMap = JSON.parse(variantRetailPricesJson);
      } catch (e) {
        retailMap = {};
      }
      const variantId = currentVariant.id;
      const retailBaseGross = (variantId in retailMap ? retailMap[variantId] : retailMap[String(variantId)]) ?? 0;
      const totalAddonBrutoForLine = totalAddonBruto > 0 ? totalAddonBruto : totalAddonForCalc;
      const totalRetailGross = retailBaseGross + totalAddonBrutoForLine;
      const displayRetail = showExclVat && vatPercentage > 0
        ? Math.round((totalRetailGross * 100) / vatDivisor)
        : totalRetailGross;
      grossPriceElement.textContent = window.Currency.formatMoney(displayRetail, window.currency.moneyFormat);
    }
  }

  getCurrentVariant() {
    const productInfo = this.closest('product-info');
    if (!productInfo) return null;
    const variantDataElement = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (variantDataElement && variantDataElement.innerHTML.trim()) {
        try {
            return JSON.parse(variantDataElement.innerHTML);
        } catch (e) {
            console.error('Error parsing variant data', e);
            return null;
        }
    }
    return null;
  }

  updateSelectedValue(selectedInput) {
    const detailsElement = selectedInput.closest('details');
    if (!detailsElement) return;

    detailsElement.classList.remove('product-variant-picker__option--required');
    const warning = detailsElement.querySelector('[data-addon-warning]');
    if (warning) warning.hidden = true;

    const selectedValueSpans = detailsElement.querySelectorAll('[data-selected-value]');
    const label = this.querySelector(`label[for="${selectedInput.id}"]`);

    if (label) {
        const titleSpan = label.querySelector('.swatch-input__label-info-text');
        const titleText = titleSpan ? titleSpan.textContent.trim() : '';
        selectedValueSpans.forEach((selectedValueSpan) => {
            selectedValueSpan.textContent = titleText;
        });
    } else {
        selectedValueSpans.forEach((selectedValueSpan) => {
            selectedValueSpan.textContent = ''; // Clear if no label found
        });
        console.warn(`AddonProduct: Label for input #${selectedInput.id} not found.`);
    }
    detailsElement.classList.add('option-selected');
    const allDetailsInAddon = Array.from(this.querySelectorAll('details.product-variant-picker__option'));
    const isLastDetails = allDetailsInAddon[allDetailsInAddon.length - 1] === detailsElement;
    if (!isLastDetails) {
      detailsElement.removeAttribute('open');
    }
    this.openNextDetails(detailsElement);
  }

  openNextDetails(currentDetailsElement) {
    const allDetailsInAddon = Array.from(this.querySelectorAll('details.product-variant-picker__option'));
    const currentIndex = allDetailsInAddon.indexOf(currentDetailsElement);

    if (currentIndex !== -1 && currentIndex < allDetailsInAddon.length - 1) {
      const nextDetailsElement = allDetailsInAddon[currentIndex + 1];
      // Open the next details element if it's not already open and no radio button inside it is checked
      if (!nextDetailsElement.hasAttribute('open') && !nextDetailsElement.querySelector('input[type="radio"]:checked')) {
        nextDetailsElement.setAttribute('open', '');
        requestAnimationFrame(() => {
          const headerBottom = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position').trim();
          const offsetPx = headerBottom ? parseInt(headerBottom, 10) : 0;
          const rect = nextDetailsElement.getBoundingClientRect();
          const targetScrollY = window.scrollY + rect.top - offsetPx;
          window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
        });
      }
    }
  }

  checkInitialAddonState() {
    const allDetailElements = this.querySelectorAll('details.product-variant-picker__option');
    let isAnyAddonSelected = false;

    allDetailElements.forEach(detailsEl => {
        const selectedRadioInDetail = detailsEl.querySelector('input[type="radio"]:checked');
        if (selectedRadioInDetail) {
            this.updateSelectedValue(selectedRadioInDetail); // This handles UI for this specific detail
            isAnyAddonSelected = true;
        } else {
            // This detail has no selection, ensure its UI reflects that
            detailsEl.classList.remove('option-selected');
            const valueSpans = detailsEl.querySelectorAll('[data-selected-value]');
            valueSpans.forEach((valueSpan) => {
                valueSpan.textContent = '';
            });
            // Do not change 'open' attribute here, respect HTML initial state
        }
    });
    this.form.hasAddons = isAnyAddonSelected;
    this.updatePrice();
    // Update submit button state after checking initial addon state
    if (this.form && typeof this.form.updateSubmitButtonState === 'function') {
      this.form.updateSubmitButtonState();
    }
  }

  conditionallyOpenFirstAddon() {
    const variantSelects = this.closest('.shopify-section').querySelector('variant-selects');
    let allVariantsSelected = true;

    if (variantSelects) {
      const allDetailsInVariantSelects = Array.from(variantSelects.querySelectorAll('details'));
      if (allDetailsInVariantSelects.length > 0) {
        allVariantsSelected = allDetailsInVariantSelects.every(detail => {
          const selectedValueSpan = detail.querySelector('[data-selected-value]');
          return selectedValueSpan && selectedValueSpan.textContent.trim() !== '';
        });
      }
    }

    if (allVariantsSelected) {
      const detailsToOpen = this.querySelector('details[data-open]');
      if (detailsToOpen) {
        detailsToOpen.setAttribute('open', '');
        detailsToOpen.classList.add('option-selectable');
      }
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }




  
}
 
  customElements.define('addon-product', AddonProduct);
}